import { render, staticRenderFns } from "./deductionTable.vue?vue&type=template&id=741cd406&"
import script from "./deductionTable.vue?vue&type=script&lang=ts&"
export * from "./deductionTable.vue?vue&type=script&lang=ts&"
import style0 from "./deductionTable.vue?vue&type=style&index=0&lang=postcss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports